import { createFileRoute } from '@tanstack/react-router';

import { RemindersScreen } from '../features/reminders/RemindersScreen';

/** `/reminders` = «التذكيرات» (§6.9). ملف المسار رقيق: التركيب كله في الميزة. */
export const Route = createFileRoute('/reminders')({ component: RemindersScreen });
